import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-mainmenu',
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.css']
})
export class MainmenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
